import { IFeatureFlagAttributes } from './types';

export const isFeatureEnabledForPartner = ({
  featureFlags,
  featureKey,
  partnerID,
  isBlacklist = false,
}: IFeatureFlagAttributes) => {
  try {
    if (!featureFlags || !featureFlags[featureKey] || !Array.isArray(featureFlags[featureKey])) return false;

    const isPartnerListed = (featureFlags[featureKey] as string[]).includes(partnerID);
    return isBlacklist ? !isPartnerListed : isPartnerListed;
  } catch (e) {
    return false;
  }
};
